import {
  Users,
  FileText,
  ShieldCheck,
  CalendarCheck,
  ShoppingCart,
  Compass,
  type LucideIcon,
} from 'lucide-react';
import type { ClusterId } from '../types/ids';

/** Ein passendes Icon je Bewertungsbereich, für Start- und Ergebnisseite. */
export const CLUSTER_ICONS: Record<ClusterId, LucideIcon> = {
  audience_demand: Users,
  topic_content: FileText,
  trust_visibility: ShieldCheck,
  daily_execution: CalendarCheck,
  sales_readiness: ShoppingCart,
  instagram_independence: Compass,
};
